import * as React from 'react';
import { QuestionCard } from '../../../../../mainv3/components/molecules/surveys/QuestionCard';
import { MultiLineStringInput, StringInput } from '../primitive/StringInput';
import './CardInput.module.scss';
import { SelectInput, SelectOptionSpec } from '../primitive/SelectInput';
import { FieldStateV3 } from '../../../../states/form/FormStateV3';
import { observer } from 'mobx-react';

interface CardInputProps {
    id?: string;
    questionNumber: number;
    totalQuestions: number;
    sentence: string;
    required: boolean;
    placeholder?: string;
    subSentence?: any;
    className?: string;
    styleName?: string;
}

interface StringInputProps extends CardInputProps {
    type?: 'text' | 'password';
    size?: 'm' | 'l';
    placeholder?: string;
    state: FieldStateV3<string>;
}

export const CardStringInput = observer(
    ({
        id,
        type = 'text',
        size = 'm',
        placeholder,
        state,
        questionNumber,
        totalQuestions,
        sentence,
        required,
        subSentence,
    }: StringInputProps) => (
        <QuestionCard
            questionNumber={questionNumber}
            totalQuestions={totalQuestions}
            sentence={sentence}
            required={required}
            subSentence={subSentence}
            errorMessage={state.getErrors().length > 0 && state.getErrors()[0]}
        >
            <div styleName="content">
                <StringInput
                    id={id}
                    type={type}
                    size={size}
                    placeholder={placeholder}
                    styleName="input"
                    value={state.getDirtyValue()}
                    onChange={state.setDirtyValue}
                    onBlur={state.validate}
                />
            </div>
        </QuestionCard>
    )
);

interface SelectInputProps<V> extends CardInputProps {
    id?: string;
    size?: 'm' | 'l';
    placeholder?: string;
    options: SelectOptionSpec<V>[];
    serializer: (v: V) => string;
    deserializer: (v: string) => V;
    state: FieldStateV3<V>;
}

export const CardSelectInput = observer(
    ({
        id,
        size = 'm',
        placeholder,
        options,
        state,
        questionNumber,
        totalQuestions,
        sentence,
        required,
        subSentence,
    }: SelectInputProps<any>) => (
        <QuestionCard
            questionNumber={questionNumber}
            totalQuestions={totalQuestions}
            sentence={sentence}
            required={required}
            subSentence={subSentence}
            errorMessage={state.getErrors().length > 0 && state.getErrors()[0]}
        >
            <div styleName="content">
                <SelectInput
                    id={id}
                    size={size}
                    options={options}
                    serializer={(v) => v}
                    deserializer={(v) => v}
                    styleName="input"
                    placeholder={placeholder}
                    value={state.getDirtyValue()}
                    onChange={state.setDirtyValue}
                    onBlur={state.validate}
                />
            </div>
        </QuestionCard>
    )
);

interface MultiLineStringInputProps extends CardInputProps {
    size?: 'm' | 'l';
    placeholder?: string;
    state: FieldStateV3<string>;
}

export const CardMultiLineStringInput = observer(
    ({
        id = undefined,
        size = 'm',
        placeholder,
        state,
        questionNumber,
        totalQuestions,
        sentence,
        required,
        subSentence,
    }: MultiLineStringInputProps) => (
        <QuestionCard
            questionNumber={questionNumber}
            totalQuestions={totalQuestions}
            sentence={sentence}
            required={required}
            subSentence={subSentence}
            errorMessage={state.getErrors().length > 0 && state.getErrors()[0]}
        >
            <div styleName="content">
                <MultiLineStringInput
                    id={id}
                    size={size}
                    placeholder={placeholder}
                    styleName="input input-multiline"
                    value={state.getDirtyValue()}
                    onChange={state.setDirtyValue}
                    onBlur={state.validate}
                />
            </div>
        </QuestionCard>
    )
);
